module.exports = {"431202001":"城中街道","431202002":"城北街道","431202003":"红星街道","431202004":"迎丰街道","431202005":"坨院街道","431202006":"河西街道","431202007":"城南街道","431202101":"黄金坳镇","431202201":"盈口乡","431202205":"凉亭坳乡","431202400":"黄岩旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431202.json
// module id = 2043
// module chunks = 0